/**
 * @generated SignedSource<<bed62cba2019efae611cc732b2fe35ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TablePagination_pageInfo$data = {
  readonly total: number;
  readonly " $fragmentType": "TablePagination_pageInfo";
};
export type TablePagination_pageInfo$key = {
  readonly " $data"?: TablePagination_pageInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TablePagination_pageInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TablePagination_pageInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    }
  ],
  "type": "PageInfo",
  "abstractKey": null
};

(node as any).hash = "d2d81fa1fd59e458be4daf4532046ab3";

export default node;
